<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <v-btn color="primary"
                       small
                       flat
                       outline
                       v-on="on"
                       class="botao-menu">
                    <i class="fas fa-download mr-2" aria-hidden="true"/>
                    Relatórios
                </v-btn>
            </template>

            <v-list class="lista-menu">
                <v-list-tile v-if="!ehCompraPropostaManualEhAtiva" @click="$emit('baixarAta')">
                    <v-list-tile-title>
                        Ata
                    </v-list-tile-title>
                </v-list-tile>

                <v-list-tile @click="$emit('baixarHistoricoLances')">
                    <v-list-tile-title>
                       Lances
                    </v-list-tile-title>
                </v-list-tile>

              <v-list-tile @click="$emit('baixarResultado')">
                <v-list-tile-title>
                  Resultado
                </v-list-tile-title>
              </v-list-tile>

              <v-list-tile v-if="ehCompraFluxoAutoridadeSuperior"
                           @click="$emit('baixarTermoHomologacao')">
                <v-list-tile-title>
                  Termo Homologação
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'AcoesRelatorios',
    props:['ehCompraFluxoAutoridadeSuperior', 'ehCompraPropostaManualEhAtiva']
}
</script>

<style scoped lang="stylus">
    .botao-menu
        text-transform capitalize
        margin 0
</style>
